import { getEnvPaths, tryLoadEnvs } from "@prisma/internals";
import * as path from "path";

export async function loadEnvironment(schemaPath: string) {
  tryLoadEnvs(
    await getEnvPaths(schemaPath, {
      cwd: path.resolve(schemaPath, "../"),
    }),
    { conflictCheck: "error" }
  );
}
